/**
 * Meta Pixel tracking utilities
 * https://developers.facebook.com/docs/meta-pixel/reference
 */

declare global {
  interface Window {
    fbq?: (
      command: string,
      eventName: string,
      eventData?: Record<string, any>,
      options?: { eventID?: string }
    ) => void;
  }
}

type StandardEvent =
  | 'CompleteRegistration'
  | 'StartTrial'
  | 'Lead'
  | 'Purchase'
  | 'AddToCart'
  | 'ViewContent';

const trackStandard = (
  eventName: StandardEvent,
  eventData?: Record<string, any>,
  eventID?: string
) => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', eventName, eventData, eventID ? { eventID } : undefined);
    } catch (error) {
      console.error(`[Meta Pixel] Failed to track event: ${eventName}`, error);
    }
  }
};

const trackCustomEvent = (
  eventName: string,
  eventData?: Record<string, any>,
  eventID?: string
) => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('trackCustom', eventName, eventData, eventID ? { eventID } : undefined);
    } catch (error) {
      console.error(`[Meta Pixel] Failed to track custom event: ${eventName}`, error);
    }
  }
};

export const trackSignUpMeta = (userId: string) => {
  trackStandard('CompleteRegistration', {}, `signup-${userId}`);
  trackStandard('StartTrial', {}, `starttrial-${userId}`);
};

export const trackProfileCompleteMeta = (userId: string) => {
  trackStandard('Lead', {}, `profile-complete-${userId}`);
};

export const trackMealPlanGenerationMeta = (
  userId: string,
  planId: string,
  recipeCount: number
) => {
  trackCustomEvent(
    'MealPlanGenerated',
    { planId, recipeCount },
    `mealplan-${userId}-${planId}`
  );
};

export const trackSubscriptionMeta = (
  userId: string,
  subscriptionId: string,
  value: number
) => {
  trackStandard(
    'Purchase',
    { value, currency: 'USD', num_items: 1 },
    `subscription-${userId}-${subscriptionId}`
  );
};
